import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CallIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "call",
  "CallIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M1.3335 2.00006H7.52397V6.31684L6.3011 6.92828C6.53839 7.49968 6.93224 8.07267 7.4299 8.57032C7.92756 9.06798 8.50054 9.46183 9.07194 9.69913L9.68338 8.47625H14.0002V14.6667H12.443C6.31314 14.6667 1.3335 9.57865 1.3335 3.31435V2.00006ZM2.66685 3.33339C2.67691 8.87929 7.08218 13.3334 12.443 13.3334H12.6668V9.80958H10.5074L9.76754 11.2893L9.24873 11.1596C8.23429 10.906 7.26021 10.2863 6.48709 9.51313C5.71397 8.74001 5.09419 7.76593 4.84058 6.75149L4.71088 6.23268L6.19064 5.4928V3.33339H2.66685Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default CallIcon;
